import { render, staticRenderFns } from "./StudioCommunityGroupDescription.vue?vue&type=template&id=e4530c9e&scoped=true&"
import script from "./StudioCommunityGroupDescription.vue?vue&type=script&lang=ts&"
export * from "./StudioCommunityGroupDescription.vue?vue&type=script&lang=ts&"
import style0 from "./StudioCommunityGroupDescription.vue?vue&type=style&index=0&id=e4530c9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4530c9e",
  null
  
)

export default component.exports